import { createSelector } from 'reselect';

const selectGiftGuide = state => state.giftGuide;

export const selectGiftGuideConfig = createSelector(
  selectGiftGuide,
  giftGuide => giftGuide.config,
);

export const selectGiftGuideHeadline = createSelector(
  selectGiftGuide,
  giftGuide => giftGuide.giftGuideHeadline,
);

export const selectGiftGuideHeadlineIsLoading = createSelector(
  selectGiftGuideHeadline,
  giftGuideHeadline => giftGuideHeadline.isLoading,
);

export const selectGiftGuideHeadlineIsLoaded = createSelector(
  selectGiftGuideHeadline,
  giftGuideHeadline => giftGuideHeadline.isLoaded,
);

export const selectGiftGuideHeadlinePlacement = createSelector(
  selectGiftGuideHeadline,
  giftGuideHeadline => giftGuideHeadline.placement,
);

export const selectGiftGuideFeaturedDeals = createSelector(
  selectGiftGuide,
  giftGuide => giftGuide.giftGuideFeaturedDeals,
);

export const selectGiftGuideFeaturedDealsIsLoading = createSelector(
  selectGiftGuideFeaturedDeals,
  giftGuideFeaturedDeals => giftGuideFeaturedDeals.isLoading,
);

export const selectGiftGuideFeaturedDealsIsLoaded = createSelector(
  selectGiftGuideFeaturedDeals,
  giftGuideFeaturedDeals => giftGuideFeaturedDeals.isLoaded,
);

export const selectGiftGuideFeaturedDealsPlacements = createSelector(
  selectGiftGuideFeaturedDeals,
  giftGuideFeaturedDeals => giftGuideFeaturedDeals.placements,
);
